import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  coursesAPI,
  CreateCourseRequest,
  UpdateCourseRequest,
} from '../api';
import { toast } from 'react-toastify';
import { useT } from '../../../i18n';

export const useGetCourses = (search?: string) =>
  useQuery({
    queryKey: ['courses', search],
    queryFn: () => coursesAPI.getAllCourses(search),
    select: (data) => data.data,
  });

export const useCreateCourse = () => {
  const qc = useQueryClient();
  const t = useT();
  return useMutation({
    mutationFn: (data: CreateCourseRequest) => coursesAPI.createCourse(data),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ['courses'] });
      toast.success(t('academy.toast.created'));
    },
    onError: (e: any) =>
      toast.error(t('academy.toast.createFailed')),
  });
};

export const useUpdateCourse = () => {
  const qc = useQueryClient();
  const t = useT();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCourseRequest }) =>
      coursesAPI.updateCourse(id, data),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ['courses'] });
      toast.success(t('academy.toast.updated'));
    },
    onError: (e: any) =>
      toast.error(t('academy.toast.updateFailed')),
  });
};

export const useDeleteCourse = () => {
  const qc = useQueryClient();
  const t = useT();
  return useMutation({
    mutationFn: (id: string) => coursesAPI.deleteCourse(id),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ['courses'] });
      toast.success(t('academy.toast.deleted'));
    },
    onError: (e: any) =>
      toast.error(t('academy.toast.deleteFailed')),
  });
};
